import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
})
